export default function SessionCheckError({ onRetry }) {
    return (
        <div role="alert" className="text-center p-8">
            <p>로그인 정보를 확인하지 못했습니다. 다시 시도해 주세요.</p>
            <button type="button" className="btn btn-primary mt-4" onClick={onRetry}>다시 시도</button>
        </div>
    );
}
